// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AlertSeverity,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  projectId: __t.u32().name("project_id"),
  eventId: __t.u64().name("event_id"),
  ruleId: __t.u64().name("rule_id"),
  get severity() {
    return AlertSeverity;
  },
  title: __t.string(),
  message: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
